<template>
  <div class="mt-4 pt-4">
    <FormRow class="mb-2">
      <template #label>Created</template>
      <template #field>
        <input type="text" class="form__input form__input--readonly" disabled :value="created" />
      </template>
    </FormRow>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      created: "-",
      updated: "-",
    };
  },
  created() {
    if (this.data.created_by) {
      this.created =
        this.data.created_by +
        " / " +
        this.dateformat(this.data.created_at);
    }

    if (this.data.updated_by) {
      this.updated =
        this.data.updated_by +
        " / " +
        this.dateformat(this.data.updated_at);
    }
  },
  props: {
    data: {
      type: Object,
    },
  },
  methods: {
    dateformat(date) {
      return this.moment(date).format("DD MMM YYYY - HH:mm");
    },
  },
};
</script>